// extracted by mini-css-extract-plugin
export default {"wrapper":"Cp","subscription":"Ep","select_item":"Fp","is_selected":"Gp","otb":"Hp","radio":"Ip","first_row":"Jp","prices":"Kp","italic":"Lp","info_wrapper":"Mp","first_month":"Np","separator":"Op","checkmark":"Pp","bullets":"Qp","bullet":"Rp","checkmarkText":"Sp","button":"Tp","discountBadge":"Up"};
    if(module.hot) {
      // 1713809675604
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  